<template>
  <div class="index_menu_item">
    <div v-if="pageName == 'overview'" class="item_overview_click">
      项目概述
    </div>
    <div v-else class="item_overview" @click="goOverview()">项目概述</div>
    <div v-if="pageName == 'progress'" class="item_progress_click">
      进度报表
    </div>
    <div v-else class="item_progress" @click="goProgress()">进度报表</div>
    <div v-if="pageName == 'indexData'" class="item_indexData_click">
      指标数据
    </div>
    <div v-else class="item_indexData" @click="goIndexData()">指标数据</div>
    <div v-if="pageName == 'review'" class="item_review_click">材料审核</div>
    <div v-else class="item_review" @click="goReview()">材料审核</div>
  </div>
</template>
<script>
export default {
  name: "ProjectMenuAdmin",
  props: {
    pageName: String,
  },
  data() {
    return {};
  },
  mounted: function() {},
  methods: {
    goOverview() {
      this.$router.push("/project/overview_admin");
    },
    goProgress() {
      this.$router.push("/project/progress");
    },
    goIndexData() {
      this.$router.push("/project/indexData");
    },
    goReview() {
      this.$router.push("/project/review");
    },
  },
};
</script>
<style scoped lang="less">
.index_menu_item {
  height: 80px;
  display: flex;
  background-color: #ffffff;
  border-bottom: 1px #f6f9fc solid;

  .item_overview {
    cursor: pointer;
    width: 192px;
    height: 100%;
    text-align: center;
    padding-top: 28px;
    color: #999999;
    font-family: "Source Han Sans CN";
    font-weight: 500;
    font-size: 24px;
  }

  .item_overview_click {
    cursor: pointer;
    width: 192px;
    height: 100%;
    text-align: center;
    padding-top: 28px;
    color: #4265ed;
    font-family: "Source Han Sans CN";
    font-weight: 500;
    font-size: 24px;
    border-bottom: 2px #4265ed solid;
  }

  .item_progress {
    cursor: pointer;
    width: 192px;
    height: 100%;
    text-align: center;
    padding-top: 28px;
    color: #999999;
    font-family: "Source Han Sans CN";
    font-weight: 500;
    font-size: 24px;
  }

  .item_progress_click {
    cursor: pointer;
    width: 192px;
    height: 100%;
    text-align: center;
    padding-top: 28px;
    color: #4265ed;
    font-family: "Source Han Sans CN";
    font-weight: 500;
    font-size: 24px;
    border-bottom: 2px #4265ed solid;
  }

  .item_indexData {
    cursor: pointer;
    width: 192px;
    height: 100%;
    text-align: center;
    padding-top: 28px;
    color: #999999;
    font-family: "Source Han Sans CN";
    font-weight: 500;
    font-size: 24px;
  }

  .item_indexData_click {
    cursor: pointer;
    width: 192px;
    height: 100%;
    text-align: center;
    padding-top: 28px;
    color: #4265ed;
    font-family: "Source Han Sans CN";
    font-weight: 500;
    font-size: 24px;
    border-bottom: 2px #4265ed solid;
  }

  .item_review {
    cursor: pointer;
    width: 192px;
    height: 100%;
    text-align: center;
    padding-top: 28px;
    color: #999999;
    font-family: "Source Han Sans CN";
    font-weight: 500;
    font-size: 24px;
  }

  .item_review_click {
    cursor: pointer;
    width: 192px;
    height: 100%;
    text-align: center;
    padding-top: 28px;
    color: #4265ed;
    font-family: "Source Han Sans CN";
    font-weight: 500;
    font-size: 24px;
    border-bottom: 2px #4265ed solid;
  }
}
</style>
